import React, { useState } from "react";
import { CancelButton, Button, PageTitle, PageSubTitle } from "./StyledElements";
import styled from "styled-components";

const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Dialog = ({ title, subtitle, okText = "OK", closeText = "Cancel", show = false, onOK = () => { }, onClose = () => { }, children = [] }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: show ? "flex" : "none",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "var(--dialog-bg)",
          padding: "20px",
          borderRadius: "8px",
          maxWidth: "400px",
          width: "100%",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <PageTitle title={title} style={{ marginBottom: "10px" }} />
        <PageSubTitle title={subtitle} style={{ marginBottom: "10px" }} />

        <DialogContent>
          {children}
        </DialogContent>


        <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "10px", marginTop: "20px" }}>
          <CancelButton onClick={onClose}>{closeText}</CancelButton>
          <Button onClick={onOK}>{okText}</Button>
        </div>
      </div>
    </div>
  )
};

export default Dialog;
